import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Container,
    Grid,
    Card,
    CardContent,
    CardMedia,
    Typography,
    CardActionArea,
} from '@mui/material';
import { fetchCategories } from '../../services/api';
import { Category } from '../../types';

const CategoryList: React.FC = () => {
    const navigate = useNavigate();
    const [categories, setCategories] = useState<Category[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadCategories = async () => {
            try {
                const data = await fetchCategories();
                setCategories(data);
            } catch (error) {
                console.error('Erreur lors du chargement des catégories:', error);
            } finally {
                setLoading(false);
            }
        };

        loadCategories();
    }, []);

    const getImageUrl = (category: Category) => {
        if (!category.imageUrl) {
            return '/uploads/products/logo.svg';
        }
        return category.imageUrl;
    };

    if (loading) {
        return (
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4, textAlign: 'center' }}>
                <Typography>Chargement...</Typography>
            </Container>
        );
    }

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Typography variant="h4" component="h1" gutterBottom>
                Nos activités
            </Typography>
            <Grid container spacing={4}>
                {categories.map((category) => (
                    <Grid item key={category._id} xs={12} sm={6} md={4}>
                        <Card>
                            <CardActionArea onClick={() => navigate(`/category/${category.slug}`)}>
                                <CardMedia
                                    component="img"
                                    height="250"
                                    image={getImageUrl(category)}
                                    alt={category.name}
                                onError={(e) => {
                                    e.currentTarget.src = '/uploads/products/logo.svg';
                                }}
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="h6" component="h2">
                                        {category.name}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.875rem' }}>
                                        {category.description}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

export default CategoryList;